import { motion } from "framer-motion";
import { Award, Briefcase, Lock, Target, MapPin } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WHY } from "../lib/content";

const ICONS = [Award, Briefcase, Lock, Target, MapPin];

// Bento-style asymmetrical grid
const SPANS = [
  "md:col-span-5",
  "md:col-span-3",
  "md:col-span-4",
  "md:col-span-4",
  "md:col-span-4",
];

export const WhyChooseUs = () => (
  <section id="why" className="relative bg-[#221b14] py-24 sm:py-36 scroll-mt-20">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Overline>Why Choose Us</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Built on Trust. Driven by{" "}
            <span className="text-gold-foil">Results.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid md:grid-cols-8 gap-5">
        {WHY.map((item, i) => {
          const Icon = ICONS[i];
          return (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden bg-zinc-950/70 border border-zinc-800/80 hover:border-amber-500/50 transition-colors duration-500 p-8 ${SPANS[i]}`}
            >
              <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full bg-amber-500/5 group-hover:bg-amber-500/10 transition-colors duration-500" />
              <div className="relative">
                <span className="flex h-14 w-14 items-center justify-center border border-amber-500/30 text-amber-400 group-hover:bg-amber-500 group-hover:text-black transition-colors duration-500">
                  <Icon className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-serif text-2xl text-white">{item.title}</h3>
                <p className="mt-3 text-zinc-400 font-light leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
